define(["require", "exports", "knockout"], function (require, exports, ko) {
    "use strict";
    var CustomerPlanItemModel = /** @class */ (function () {
        function CustomerPlanItemModel(data) {
            this.Id = ko.observable(0);
            this.Name = ko.observable();
            this.BillItemName = ko.observable();
            this.BillItemDesc = ko.observable();
            this.CustomerId = ko.observable(0);
            this.CallPlanId = ko.observable();
            this.CustomerCallPlanId = ko.observable(0);
            //CallType = ko.observable<string>();
            this.CallTypes = ko.observableArray();
            this.AdditionalCallTypes = ko.observableArray();
            this.RateType = ko.observable();
            this.IsFlat = ko.observable(true);
            this.Rate = ko.observable(0);
            this.RateFormat = ko.observable("c5");
            this.StartRange = ko.observable(0);
            this.EndRange = ko.observable(0);
            this.IsDeleted = ko.observable(false);
            this.SplitByNumber = ko.observable(false);
            var self = this;
            if (data) {
                ko.mapping.fromJS(data, CustomerPlanItemModel.Mapping, self);
            }
            if (self.IsFlat()) {
                if (self.RateType() === "6") {
                    self.RateFormat("n1");
                }
                else {
                    self.RateFormat("c5");
                }
            }
            else {
                if (self.RateType() === "6") {
                    self.RateFormat("c1");
                }
                else {
                    self.RateFormat("p1");
                }
            }
            self.RateType.subscribe(function (value) {
                if (self.IsFlat()) {
                    if (self.RateType() === "6") {
                        self.RateFormat("n1");
                        self.Rate(self.Rate() * 1);
                    }
                    else {
                        self.RateFormat("c5");
                        self.Rate(self.Rate() * 1);
                    }
                }
                else {
                    if (self.RateType() === "6") {
                        self.RateFormat("c1");
                        self.Rate(self.Rate() * 1);
                    }
                    else {
                        self.RateFormat("p1");
                        self.Rate(self.Rate() / 1);
                    }
                }
            });
            self.IsFlat.subscribe(function (value) {
                if (value) {
                    if (self.RateType() === "6") {
                        self.RateFormat("n1");
                        self.Rate(self.Rate() * 1);
                    }
                    else {
                        self.RateFormat("c5");
                        self.Rate(self.Rate() * 1);
                    }
                }
                else {
                    if (self.RateType() === "6") {
                        self.RateFormat("c1");
                        self.Rate(self.Rate() * 1);
                    }
                    else {
                        self.RateFormat("p1");
                        self.Rate(self.Rate() / 1);
                    }
                }
            });
        }
        CustomerPlanItemModel.Mapping = {
            key: function (data) {
                return data.Id;
            },
            create: function (options) {
                return new CustomerPlanItemModel(options.data);
            }
        };
        return CustomerPlanItemModel;
    }());
    return CustomerPlanItemModel;
});
//# sourceMappingURL=CustomerPlanItemModel.js.map


//////////////////
// WEBPACK FOOTER
// ./build/models/CustomerPlanItemModel.js
// module id = 71
// module chunks = 2